import Button from './button'

Button.install = vue => vue.component(Button.name, Button)

export default Button
